module.exports = __webpack_public_path__ + "img/bg_pos.4ca488f6.jpg";